import {ChangeDetectorRef, Component, ViewChildren, ViewChild, QueryList, ElementRef, OnInit} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { applyMixins, getAvailableLanguages } from 'utils/utils';
import { LanguagePageMixin } from 'shared/language-page/language-page-mixin';
import { BrandService } from 'shared/brand/brand.service';
import { SearchService } from 'shared/search/search.service';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { segmentsData } from '../../../product-details/segments-data-stub';
import { ProductPanelService } from '../../product-panel.service';
import { ItemDetailService } from 'shared/item-detail/item-detail.service';
import { DescriptionFormModel } from './description-form.model';
import { ECOMMERCE_PANEL } from '../../../product-panel/product-panel-types';

import { AppSummaryModalComponent } from '../../components/app-summary-modal/app-summary-modal.component';
import { SimpleConfirmModalComponent } from 'shared/modal/simple-confirm-modal/simple-confirm-modal.component';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';


@Component({
  moduleId: module.id,
  selector: 'description-segment',
  templateUrl: 'description.component.html',
  styleUrls: ['description.component.scss'],
})
class DescriptionComponent extends BaseSegmentComponent implements LanguagePageMixin, OnInit {

  @ViewChildren('loopingControl') loopingControls: QueryList<ElementRef>;

  @ViewChild('appSummaryModal', {static: false})
  appSummaryModal: AppSummaryModalComponent | void;

  /*
   * The Confirmation Modal used when the App Summary Modal is completed.
   */
  @ViewChild('confirmAppSummaryChangeModal', {static: false})
  confirmAppSummaryChangeModal: SimpleConfirmModalComponent | void;

  descriptionFormGroup: UntypedFormGroup;
  descriptionFormModel: DescriptionFormModel;

  showMore: boolean = false;
  showMoreData: any = [];
  selectedLanguage: string = 'EN';
  languagesItems: any[] = [];
  loopingFields: string[] = [
    'asc', 'mkt'
  ];
  segmentName: string = 'descriptions';
  panelTypeFields: any = {
    [ECOMMERCE_PANEL]: [
      'descriptions.DES', 'descriptions.EXT', 'descriptions.ASC',
      'descriptions.MKT', 'descriptions.SHP'
    ],
  };

   /*
   * appSummaryData has 2 fields
   *  appSummary is the current App Summary for the item detail record
   *  selectedAppSummary is the app summary selected from the App Summary Modal
   */
  appSummaryData: any = {
    appSummary: {
      template_id: null,
      custom_value: null
    },
    selectedAppSummary: null
  };

  getItemLanguages: (item: any) => string[];

  getLanguagePath: (item: any) => string;

  addLanguages: (data: any) => void;

  get segmentForm(): UntypedFormGroup {
    return this.descriptionFormGroup;
  }

  constructor(
    protected productPanelService: ProductPanelService,
    protected brandService: BrandService,
    protected itemDetailService: ItemDetailService,
    protected searchService: SearchService,
    protected route: ActivatedRoute,
    protected ref: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
  ) {
    super(productPanelService, brandService, itemDetailService, searchService, route, ref);
  }

  get display() {
    return _.filter(this.data, (item: any) => {
        return item.show_more;
    });
  }

  get displayShowMore() {
    return _.filter(this.data, (item: any) => {
        return !item.show_more;
    });
  }

  /*
   * Set the English version of the Application summary in the Components form
   */
  set appSummary(appSummary: string) {
    this.segmentForm.get('en').get('asm').setValue(appSummary);
  }
  /*
   * Get the Application Summary text from the components form
   */
  get appSummaryTemplateId() {
    return this.segmentForm.get('appSummaryTemplateId').value;
  }
  /*
   * Set the Application Summary Template Id in the Components form
   */
  set appSummaryTemplateId(appSummaryTemplateId: number) {
    this.segmentForm.get('appSummaryTemplateId').setValue(appSummaryTemplateId);
  }

  ngOnInit() {
    this.data = this.getPanelSegmentsData(segmentsData.descriptions);
    if (this.panelType === ECOMMERCE_PANEL) { this.showMore = true; }
    this.languagesItems = getAvailableLanguages();

    /*
      Initialize form
    */
    this.descriptionFormGroup = this.fb.group({});

    this.descriptionFormGroup = this.fb.group({
      en: this.fb.group(this.languageFormGroup(this.data)),
      es: this.fb.group(this.languageFormGroup(this.data)),
      fr: this.fb.group(this.languageFormGroup(this.data)),
    });

    /*
     Subscribe to Item Detail service
    */
    this.subscribeToItemDetail();
  }


    /*******************************************
  * APP SUMMARY MODAL HANDLERS
  *******************************************/
  /*
   * Show the App Summary Modal
   */
  appSummaryShow() {

    let appSummary = {
      template_id: 0,
      custom_value: ''
    };

    const appSummaryTemplateId = this.appSummaryData.appSummary.template_id;
    const customValue = this.appSummaryData.appSummary.custom_value;
    appSummary = {
      template_id: appSummaryTemplateId,
      custom_value: customValue
    };
    this.appSummaryData.appSummary = appSummary;
    if (this.appSummaryModal instanceof AppSummaryModalComponent) {
      this.appSummaryModal.show(null, appSummary, this.bulkEdit);
    }
  }

    /*
   * Fires when the Application Summary is completed.
   * It is bound to the event onAppSummaryCompleted fired from the App Summary Modal
   * The descriptions html template sets the binding.
   */
  onAppSummaryCompleted(appSummary: any) {
    console.log('completedSummary', appSummary);
    this.appSummaryData.selectedAppSummary = appSummary;
    _.delay(() => {
      if (this.confirmAppSummaryChangeModal instanceof SimpleConfirmModalComponent) {
        this.confirmAppSummaryChangeModal.show();
      }
    }, 200);
  }

  /*
   *  Fires when the Application Summary confirmation Modal is confirmed Yes.
   *  it is bound to the event secondaryBtnClick on the Confirmation Modal
   *  The descriptons html template sets the binding
   */
  onAppSummaryChangeConfirm() {
    console.log('selected summary', this.appSummaryData);
    this.updateAppSummary(this.appSummaryData.selectedAppSummary);
    this.appSummaryData.selectedAppSummary = null;
  }

  /*
   *  Fires when the Application Summary confirmation Modal is confirmed No.
   *  it is bound to the event primaryBtnClick on the Confirmation Modal
   *  The descriptons html template sets the binding
   */
  onAppSummaryChangeCancel() {
    const appSummaryTemplateId = _.get(this.appSummaryData.selectedAppSummary, 'template_id', 0);
    let customValue = '';
    if (appSummaryTemplateId === 0) {
      customValue = _.get(this.appSummaryData.selectedAppSummary, 'app_summary');
    } else {
      if (!this.bulkEdit) {
        customValue = _.get(this.itemDetailsData, 'descriptions.ASM.EN', '');
      }
    }
    const appSummary = {
      template_id: appSummaryTemplateId,
      custom_value: customValue
    };
    if (this.appSummaryModal instanceof AppSummaryModalComponent) {
      this.appSummaryModal.show(null, appSummary, this.bulkEdit);
    }
    this.appSummaryData.selectedAppSummary = null;
  }

  /*
   * Updates all of the necessary fields when the changing of an App Summary is Confirmed.
   */
  updateAppSummary(appSummary: any) {
    console.log('appSummary', appSummary);
    console.log('appSummaryData.appSummary', this.appSummaryData.appSummary);

    this.descriptionFormGroup.addControl('appSummaryTemplateId', new UntypedFormControl(this.appSummaryData.appSummary.template_id));

    this.appSummaryData.appSummary.template_id = appSummary.template_id;
    if (appSummary.template_id === 0 ) {
      this.appSummaryData.appSummary.custom_value = appSummary.app_summary;
    }
    this.appSummary = appSummary.app_summary;
    this.appSummaryTemplateId = appSummary.template_id;
    this.markAsDirty();
  }

  // replace parent method:
  handleItemDetail(itemDetail: any) {
    this.itemDetailsData = itemDetail;
    this.setData(itemDetail);
  }

  // replace parent method:
  setBulkData() {
    this.setData({
      descriptions: this.getBulkSegmentData(this.segmentName)
    });
  }

  buildLoopingFormArray(itemDetail: any, item: any, language: string, validators: any[]) {
    if (_.has(itemDetail, item.item_name + '.' + language.toUpperCase())) {
      const oData: any = _.get(itemDetail, item.item_name + '.' + language.toUpperCase());
      const formGroup: any = this.descriptionFormGroup.controls[language.toLowerCase()];
      let formArray: any = formGroup.get(item.field_map);
      // reset formArray if array already has data
      if (formArray.length) {
        formGroup.setControl(item.field_map, new UntypedFormArray([]));
        formArray = formGroup.get(item.field_map);
      }
      _.each(oData, (desc) => {
        formArray.push(new UntypedFormControl(desc,  validators));
      } );
    }

  }

  languageFormGroup(data: any[]): DescriptionFormModel {
    const descriptionFormModel: DescriptionFormModel = new DescriptionFormModel();
    _.each(data, (d: any) => {

      if (d.field_map) {
        let validators: Array<any> = [];

        validators = this.initDescriptionValidation(d, 'pies65');

        if (d.type === 'list') {
          _.set(descriptionFormModel, d.field_map, new UntypedFormArray([]));
        } else {
          _.set(descriptionFormModel, d.field_map, new UntypedFormControl(_.get(d, 'default_value', ''),  validators) );
        }
      }

    });

    return descriptionFormModel;
  }

  getDescriptionLanguages(item: any, formGroup: UntypedFormGroup): string[] {
    const languages: string[] = [];

    _.each(_.keys(formGroup.controls), (language) => {
      if (formGroup.controls[language].get(item.field_map) && formGroup.controls[language].get(item.field_map).value.length) {
        languages.push(language.toUpperCase());
      }
    });

    return languages;
  }

  getItemHintSubtitle(item: SegmentFieldItem): string {
    if (['asc', 'mkt', 'fab'].indexOf(item.field_map) === -1) {
      return `* The values entered <strong>will overwrite</strong> any current values.`;
    }
    return `* The values entered will be <strong>added as a new entry</strong>, keeping any current values instead of overwriting them.`;
  }

  isLoopingField(item: any): boolean {
    return (item.type === 'list');
  }

  initDescriptionValidation(item: any, type: string) {
    let validators: any = [];
    if (_.has(item, 'validation.' + type )) {
      validators = this.initValidators(item.validation[type]);
      if (item.validation[type].maxLength) {
        item.maxLength = item.validation[type].maxLength;
      }
    }
    return validators;
  }

  getLoopingformArray(fieldMap: string, language: string): UntypedFormArray {
    return this.descriptionFormGroup.controls[language].get(fieldMap) as UntypedFormArray;
  }

  save(): Observable<any> {
    if (this.bulkEdit) {
        console.log('Bulk Edit', 'save');
      return this.putDataBulk(
        this.segmentName,
        this.descriptionFormGroup.value,
        this.prepareBulkData(this.descriptionFormGroup.value)
      );
    } else {
      const { id } = this.route.snapshot.params;
      return this.putData(id, this.segmentName, this.descriptionFormGroup.value);
    }
  }


  setData(itemDetail: any = {}): void {
    this.itemDetailsData = itemDetail;


    _.each(this.data, (o: any) => {

      if (o.field_map) {
        if (o.type === 'list') {
          let validators: Array<any> = [];
          validators = this.initDescriptionValidation(o, 'pies65');

          this.buildLoopingFormArray(itemDetail, o, 'en', validators);
          this.buildLoopingFormArray(itemDetail, o, 'es', validators);
          this.buildLoopingFormArray(itemDetail, o, 'fr', validators);

        } else {
          this.descriptionFormGroup.controls['en'].get(o.field_map).setValue(_.get(itemDetail, o.item_name + '.EN', ''));
          this.descriptionFormGroup.controls['es'].get(o.field_map).setValue(_.get(itemDetail, o.item_name + '.ES', ''));
          this.descriptionFormGroup.controls['fr'].get(o.field_map).setValue(_.get(itemDetail, o.item_name + '.FR', ''));
        }
      }
    });
    /*
     * Set the App Summary Template Id
     */
    const appSummaryTemplateId = 0;
    const appSummaryCustomValue = '';
    if (itemDetail) {
      this.appSummaryData.appSummary.template_id  = _.get(itemDetail, 'app_summary.template_id', 0);
      this.appSummaryData.appSummary.custom_value = _.get(itemDetail, 'app_summary.custom_value', '');
    }

  }

  // handlers
  onClickItem(item: any) {
    console.log(item);
    if (item.field_map === 'asm') {
      this.appSummaryShow();
    }
  }

  onLanguageChange(event: any) {
    this.selectedLanguage = event.code;
    // change textarea's text according to selected language
  }

  onAddAnotherClick(item: any, language: string) {
    let validators: any = [];
    validators = this.initDescriptionValidation(item, 'pies65');

    const formArray: any = this.getLoopingformArray(item.field_map, language);
    formArray.push(new UntypedFormControl('',  validators));
    this.focusOnLastLoopingControl(item.field_map);
    this.markAsDirty();
  }

  onDeleteControlClick(control: UntypedFormControl, fieldMap: string, language: string) {
    const formArray: any = this.getLoopingformArray(fieldMap, language);
    if (!formArray) { return console.warn('formArray not found!'); }
    const index = formArray.controls.indexOf(control);
    formArray.removeAt(index);
    this.markAsDirty();
  }

  // private
  private focusOnLastLoopingControl(fieldMap: string): void {
    _.delay(() => {
      const controls: Array<ElementRef> = this.loopingControls.filter((element: ElementRef) => {
        return element.nativeElement.classList.contains(fieldMap);
      });
      controls.pop().nativeElement.focus();
    }, 0);
  }

  private prepareBulkData(data: any): any {
    const result = {};
    _.each(data, (value: any, key: string) => {
      const lang = key.toUpperCase();
      _.each(value, (_value, _key: string) => {
        _.set(result, `${_key.toUpperCase()}.${lang}`, _value);
      });
    });
    return result;
  }

  private getBadgeVariation(item: any, language: any): string {
    const descrLangFG = this.descriptionFormGroup.controls[language.toLowerCase()];
    // show badge danger if we have description error for this language
    if (
      !this.isLoopingField(item) &&
      descrLangFG &&
      this.hasError(item.field_map, descrLangFG)
    ) {
      return 'danger';
    }
    return 'default';
  }
}

applyMixins(DescriptionComponent, [LanguagePageMixin]);

export { DescriptionComponent };
